/* Guides index: category pills and search.

   Every guide is server-rendered so the library is fully indexable; this only
   hides and shows. With JS off, all guides remain visible and every card is
   still a working link.

   The featured card participates in filtering too — otherwise picking a
   category could leave a guide on screen that does not belong to it. */
(function () {
  var pills = Array.prototype.slice.call(document.querySelectorAll('.dg-pill'));
  var search = document.getElementById('dg-search');
  var grid = document.getElementById('dg-grid');
  var none = document.getElementById('dg-none');
  var featured = document.querySelector('.dg-featured');

  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.dg-card')) : [];
  var items = cards.slice();
  if (featured) items.push(featured);
  if (!items.length) return;

  var activeTag = '';

  function tagsOf(el) {
    return (el.dataset.tag || '').split(';').map(function (s) { return s.trim(); });
  }

  function apply() {
    var q = search ? (search.value || '').trim().toLowerCase() : '';
    var shown = 0;

    items.forEach(function (el) {
      var ok = true;
      if (activeTag && tagsOf(el).indexOf(activeTag) === -1) ok = false;
      if (ok && q && (el.dataset.search || '').indexOf(q) === -1) ok = false;
      el.hidden = !ok;
      if (ok) shown++;
    });

    if (none) none.hidden = shown !== 0;
  }

  pills.forEach(function (p) {
    p.addEventListener('click', function () {
      activeTag = p.dataset.tag || '';
      pills.forEach(function (o) {
        var on = o === p;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-pressed', String(on));
      });
      apply();
    });
    p.setAttribute('aria-pressed', String(p.classList.contains('is-active')));
  });

  if (search) search.addEventListener('input', apply);

  apply();
})();
